import {useTranslation} from '@wix/yoshi-flow-editor'
import React from 'react'
import {useCurrencyFormatter} from '../../../../../../../commons/hooks/currency'
import {getSummaryPlaceInfo, getSummaryTicketName} from '../../../../selectors/placed-order'
import {SummaryRow} from '../summary-row'
import {SeatTicketProps} from './interfaces'
import s from './seat-ticket.scss'

export const SeatTicket = ({ticket, ticketDetails}: SeatTicketProps) => {
  const {t} = useTranslation()
  const {getFormattedMoney} = useCurrencyFormatter()

  const {sectionTitle, elementTitle, area, table, seatLabel} = getSummaryPlaceInfo(ticketDetails)
  const formattedPrice = getFormattedMoney({
    amount: ticketDetails.priceOverride ?? ticket.price.amount,
    currency: ticket.price.currency,
  })

  return (
    <div className={s.container}>
      <SummaryRow label={getSummaryTicketName(ticket, ticketDetails)} value={formattedPrice} />
      <div className={s.seatDetails}>
        <SummaryRow label={t('seatings_sector')} value={sectionTitle} size="small" textValue />
        {area ? (
          <SummaryRow label={t('seatings_area')} value={elementTitle} size="small" textValue />
        ) : (
          <>
            <SummaryRow
              label={table ? t('seatings_table') : t('seatings_row')}
              value={elementTitle}
              size="small"
              textValue
            />
            <SummaryRow label={t('seatings_seat')} value={seatLabel} size="small" textValue />
          </>
        )}
      </div>
    </div>
  )
}
